angular.module("ainapp")
    .controller("vatReportController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService","$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Vat Report";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {

                var startdate = new Date(new Date().getFullYear(), 0, 1);

                $scope.filter = {
                    FromDate: startdate,
                    ToDate: new Date(),
                }

            }
            $scope.Init();


            $scope.filterReport = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.VatData = {};
                $scope.filter.FromDateString = $scope.extractDate($scope.filter.FromDate);
                $scope.filter.ToDateString = $scope.extractDate($scope.filter.ToDate);

                MainService.GetVatReport($scope.filter).then(function (response) {
                    $scope.VatData = response.data;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }

            $scope.Print  = function(){

                $.LoadingOverlay("show", {
                image: "images/load.gif",
            });

            $scope.VatData.Fromdate = $scope.extractDate($scope.filter.FromDate);
            $scope.VatData.ToDate = $scope.extractDate($scope.filter.ToDate);
            
            MainService.PrintVatReport($scope.VatData).then(
                function (response) {
                    if (response.data != null) {
                        $window.open(
                            config.basePath + "/Reports/" + response.data,
                            "_blank"
                        );
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                },
                function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }
            );

            }


        }])
